export const stateCityType = {
  GET_STATE: "[REQUEST] Get State Data",
  GET_STATE_SUCCESS: "[RESPONSE] Get State Data Successfull",
  GET_STATE_FAILURE: "[RESPONSE] Get State Data Failed",
  GET_CITY: "[REQUEST] Get City Data",
  GET_CITY_SUCCESS: "[RESPONSE] Get City Data Successfull",
  GET_CITY_FAILURE: "[RESPONSE] Get City Data Failed",
};
